import * as Yup from "yup";

const baseSchema = Yup.object({
  title: Yup.string()
    .required("عنوان الزامی است")
    .min(3, "کمتر از سه کاراکتر نمی‌تواند باشد"),
  department_id: Yup.string().required("انتخاب دسته‌بندی الزامی است"),
  tags: Yup.string()
    .transform((value, originalValue) =>
      Array.isArray(originalValue) ? originalValue.join(",") : value
    )
    .required("حداقل سه تگ مورد نیاز است")
    .test(
      "min-tags",
      "حداقل سه تگ باید وارد شود",
      (value: any) =>
        value &&
        value
          .split(/[,،]/)
          .map((tag: string) => tag.trim())
          .filter((tag: string) => tag.length > 0).length >= 3
    ),
  index_picture: Yup.string().required("ثبت تصویر الزامی است"),
  content: Yup.string().required("محتوا الزامی است"),
  description: Yup.string()
    .required("توضیحات کوتاه الزامی است")
    .min(100, "این توضیحات باید حداقل 30 کلمه باشد"),
});

export const articleValidationSchema = baseSchema.concat(
  Yup.object({
    author: Yup.string().required("نام نویسنده الزامی است"),
  })
);

export const newsValidationSchema = baseSchema;
export const projectValidationSchema = baseSchema;
